import { Recette } from './../../../../models/recette.model';
import { Periode } from './../../../../models/periode.model';
import { Component, OnInit, Input } from '@angular/core';
import { PeriodeService } from '../../../../services/periode.service';
import { LocalDataSource } from 'ng2-smart-table';

@Component({
  selector: 'app-tabModificationPeriode',
  templateUrl: './tabModificationPeriode.component.html',
  styleUrls: ['./tabModificationPeriode.component.scss']
})
export class TabModificationPeriodeComponent implements OnInit {

  @Input() periodes: Periode[];
  @Input() recette: Recette;
  periode: Periode;
  defaultOrdre: number;
  source: LocalDataSource;
  constructor(private periodeService: PeriodeService) {
    this.source = new LocalDataSource();
  }

  ngOnInit() {
  }

  settings = {
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmCreate: true,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      ordre: {
        title: 'Ordre',
        type: 'number',
        editable: false,
        addable: false,
      },
      libelle: {
        title: 'Libellé',
        type: 'string',
      },
      duree: {
        title: 'Durée',
        type: 'number',
      },
      duree_jour: {
        title: 'Durée jour',
        type: 'number',
      },
      duree_nuit: {
        title: 'Durée nuit',
        type: 'number',
      },
      nightbreak: {
        title: 'Nightbreak',
        type: 'number',
      },
      nightbreak_duree: {
        title: 'Nightbreak durée',
        type: 'number',
      },
      intervalle_arrosage: {
        title: 'Intervalle arrosage',
        type: 'number',
      },
    },
  };
  onDeleteConfirm(event): void {
    if (window.confirm('Etes-vous sûr de vouloir supprimer la période ?')) {
      this.periodeService.deletePeriode(event.data, this.periodes, this.recette.id);
      event.confirm.resolve();
    } else {
      event.confirm.reject();
    }
  }

  createPeriode(event) {
    if (window.confirm('Etes-vous sûr de vouloir ajouter la période ?')) {
      this.periodeService.addPeriode(event.newData, this.periodes, this.recette.id)
      .subscribe(periode => {
        this.source.setSort([{ field: 'ordre', direction: 'asc' }]);
        event.confirm.resolve(periode);
      });
    }
  }
}
